import { apiFetch } from '../api-client';

export type VoucherStatus = 'DRAFT' | 'POSTED';

export interface DepreciationVoucher {
  id: string;
  code: string;
  period: string;
  status: VoucherStatus;
  totalAmount: number;
  totalAssets: number;
  notes: string | null;
  createdBy: string;
  createdAt: string;
  postedBy: string | null;
  postedAt: string | null;
}

export interface DepreciationVoucherLine {
  id: string;
  voucherId: string;
  assetId: string;
  assetCode: string;
  assetName: string;
  department: string | null;
  cost: number;
  monthlyDepreciation: number;
  costAccount: string | null;
  depreciationAccount: string | null;
}

export interface CalcLine {
  assetId: string;
  assetCode: string;
  assetName: string;
  department: string | null;
  categoryCode: string;
  categoryName: string;
  cost: number;
  monthlyDepreciation: number;
  costAccount: string | null;
  depreciationAccount: string | null;
  method: string;
  effectiveYears: number;
  depreciationStart: string;
}

export interface CalcResult {
  period: string;
  totalAmount: number;
  totalAssets: number;
  lines: CalcLine[];
  skipped: Array<{ assetCode: string; assetName: string; reason: string }>;
}

export const depreciationVouchersApi = {
  calculate: (period: string) =>
    apiFetch<CalcResult>(`/api/depreciation-vouchers/calculate?period=${encodeURIComponent(period)}`),
  list: () => apiFetch<{ items: DepreciationVoucher[] }>('/api/depreciation-vouchers'),
  findOne: (id: string) =>
    apiFetch<DepreciationVoucher & { lines: DepreciationVoucherLine[] }>(`/api/depreciation-vouchers/${id}`),
  create: (period: string, lines: Array<{ assetId: string; monthlyDepreciation: number }>) =>
    apiFetch<DepreciationVoucher>('/api/depreciation-vouchers', {
      method: 'POST',
      body: JSON.stringify({ period, lines }),
    }),
  post: (id: string) =>
    apiFetch<DepreciationVoucher>(`/api/depreciation-vouchers/${id}/post`, { method: 'POST' }),
  remove: (id: string) =>
    apiFetch<{ ok: true }>(`/api/depreciation-vouchers/${id}`, { method: 'DELETE' }),
};
